function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { POSITIONS } from './constants';
export var isTopPosition = function isTopPosition(position) {
  if (position === POSITIONS.TopStart || position === POSITIONS.TopCenter || position === POSITIONS.TopEnd) {
    return true;
  }

  return false;
};
export var updateToastsToRender = function updateToastsToRender(_ref) {
  var toastsToDisplay = _ref.toastsToDisplay,
      toastsToRender = _ref.toastsToRender,
      setToastsToRender = _ref.setToastsToRender;
  var toastsToAdd = {};
  Object.keys(toastsToDisplay).forEach(function (id) {
    // If a new toast was added to toastsToDisplay, check if it's present
    // in toastsToRender
    if (!toastsToRender[id]) {
      toastsToAdd[id] = toastsToDisplay[id];
    }
  }); // Only call setToastsToRender if there are toasts waiting in toastsToAdd

  if (Object.keys(toastsToAdd).length > 0) {
    setToastsToRender(_objectSpread(_objectSpread({}, toastsToRender), toastsToAdd));
  }
};